export const moduleName = 'cookies';

export default {
  SET_COOKIES_SETTINGS_OPEN: `${moduleName}/SET_COOKIES_SETTINGS_OPEN`,
};
